import { Getter } from "vuex";
import { IState } from './state';

const news: Getter<IState, IState> = (state) => state.news
const total: Getter<IState, IState> = (state) => state.total
const categoryFilter: Getter<IState, IState> = (state) => state.categoryFilter
const date: Getter<IState, IState> = (state) => state.date
const pages: Getter<IState, IState> = (state) => state.pages
const page: Getter<IState, IState> = (state) => state.page
const query: Getter<IState, IState> = (state) => state.query
const title: Getter<IState, IState> = (state) => state.title
const description: Getter<IState, IState> = (state) => state.description
const translations: Getter<IState, IState> = (state) => state.translations

// For history
const getParams: Getter<IState, IState> = (state) => {

	// For every part of array state.categoryFilter we get its id and values
	const categoryFilter = JSON.stringify(state.categoryFilter.map(cf => {
		return {
			identifier: cf.identifier,
			values: cf.values.filter(v => v.selected).map(v => v.value)
		}
	}))

	const sort = JSON.stringify(state.sort.find(s => s.active))
	
	const dateStart = state.date.start && new Date(state.date.start).getTime()
	const dateEnd = state.date.end && new Date(state.date.end).getTime()

	const params = {
		query: state.query,
		page: state.page,
		startDate: dateStart,
		endDate: dateEnd,
		filters: categoryFilter,
		sort: sort
	}

	return params
}

// If filters has been used: return true. For reset filter function
const hasFilters: Getter<IState, IState> = (state) => {
	const filtersCount = state.categoryFilter.reduce((acc, curr) => {
		return acc + curr.values.filter(v => v.selected).length;
	}, 0);

	return filtersCount > 0 || state.date.start != '' || state.date.end != '';
}

const sorts: Getter<IState, IState> = (state) => state.sort
const extraLinks: Getter<IState, IState> = state => state.extraLinks

export default {
	news,
	total,
	categoryFilter,
	date,
	pages,
	page,
	query,
	getParams,
	hasFilters,
	title,
	description,
	sorts,
	translations,
	extraLinks,
}
